import { Store, StoreConfig } from '@datorama/akita';
import { iStoreActions } from '../core/store-actions.interface';
import { PartyMiscModel } from '../../cmg-1003/models/party-misc.model';
import { Injectable } from '@angular/core';

function createInitialState(): PartyMiscModel {
  return <PartyMiscModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-party-misc' })
export class PartyMiscStore extends Store<PartyMiscModel> implements iStoreActions<PartyMiscModel> {
  private _initValue: PartyMiscModel = null;
  constructor() {
    super(createInitialState());
  }

  preInitialize(partyMisc: PartyMiscModel): void {
    // Reset; do not use values from local storage
    this.reset();
    this.update(partyMisc);
  }

  get initialValue() {
    return this._initValue;
  }
}
